import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import Analytics from "../../../analytics";
import { GridRow } from "arv-reactcomponents";
import Event from "../../../analytics/eventFactory";
import PaymentGateway from "../../PaymentGateway";
import PaymentCard from "../PaymentCard";


@inject("PaymentStore", "WalletStore")
@observer
class E_Wallet extends Component {
  constructor(props) {
    super(props);
    this.toggleValue = this.toggleValue.bind(this);
  }

  toggleValue(e, wallet) {
    e.preventDefault();
    if (e.key && e.key !== "Enter") {
      return;
    }
    const { eWalletOptions = {} } = this.props.WalletStore;
    const walletDetails = eWalletOptions[wallet];
    this.props.WalletStore.toggleWalletOptions(wallet);
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.PAYMENT_WALLET_SELECTED(walletDetails.walletName),
      label: walletDetails.requestedPG || "",
    });
  }


  get paymentCards() {
    const { eWalletOptions = {}, walletSelection } = this.props.WalletStore;
    const walletOptionsList =
      (eWalletOptions && Object.keys(eWalletOptions)) || [];
    return walletOptionsList.map(wallet => {
      const imageUrl = eWalletOptions[wallet] && eWalletOptions[wallet].imageUrl;
      const walletName = eWalletOptions[wallet] && eWalletOptions[wallet].walletName || "";
      const selectedClassName = walletSelection[wallet] && "nw-paymentcard-selected" || "";
      const isChecked = walletSelection[wallet];
      const paymentCardDetails = {
        name: walletName,
        code: wallet,
        image: imageUrl,
        className: 'walletoptions',
        onChange: this.toggleValue,
        isChecked,
        selectedClassName,
        selectedPayment: wallet,
      }
      return <PaymentCard.component paymentCardDetails={paymentCardDetails} />
    });
  }

  render() {
    const { selectedWalletCode, walletSuccess } = this.props.WalletStore;
    const paymentDatawithWallet = { ...walletSuccess, selectedWalletCode };
    return (
      <GridRow className="nw-wallet-section">
        {this.paymentCards}
        {selectedWalletCode && paymentDatawithWallet && paymentDatawithWallet.transactions && paymentDatawithWallet.transactions.banking &&
          <PaymentGateway.component
            success={paymentDatawithWallet}
            componentName="E_Wallet"
          />}
      </GridRow>
    );
  }
}

E_Wallet.wrappedComponent.propTypes = {
  WalletStore: PropTypes.shape({
    walletOptions: PropTypes.shape({}).isRequired,
    eWalletOptions: PropTypes.shape({}).isRequired,
    walletSelection: PropTypes.shape({}).isRequired,
    setSelectedWallet: PropTypes.func.isRequired,
    toggleWalletOptions: PropTypes.func.isRequired,
  }).isRequired,
  PaymentStore: PropTypes.shape({
    paymentOptionsSelection: PropTypes.shape({}).isRequired,
  }).isRequired,
};

E_Wallet.wrappedComponent.propTypes = {};
const getFinalComponent = component =>
  inject("PaymentStore", "WalletStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: E_Wallet.wrappedComponent,
  component: E_Wallet,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/E_Wallet/index.js